import { optionsObjectToArray } from "@/common/utils/optionsObjectToArray";

export const negotiationStatus = {
  awaiting_establishment_response: 'Enviado ao estabelecimento',
  awaiting_client_response: 'Pendente resposta',
  accepted: 'Efetivado',
  canceled: 'Cancelado',
  rejected: 'Recusado',
  expired: 'Encerrado',
};

export const negotiationStatusOptions = optionsObjectToArray(negotiationStatus);

export const negotiationProductStatus = {
  pending: 'Pendente',
  accepted: 'Aprovado',
  rejected: 'Recusado',
};

export const negotiationProductValueLabelByStatus = {
  pending: 'Valor desejado',
  accepted: 'Valor negociado',
  rejected: 'Valor recusado',
};

export const negotiationProductValueLabelByAction = {
  counter: 'Valor desejado',
  accept: 'Valor negociado',
  reject: 'Valor recusado',
};
